import { Component, Injector, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DeleteGroupDialogContentComponent } from '@components/dialog/delete-group-dialog/delete-group-dialog-content/delete-group-dialog-content.component';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ChargingstationGroupDto } from '@dto/chragingstationGroupDto';
import { UserDto } from '@dto/userDto';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from '@services/entity/users.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { tr } from 'date-fns/locale';
import Swal from 'sweetalert2';
import { AbstractDialogContent } from '../../../../abstracts/dialog/dialog-content';
import { ChargingstationGroup } from '../../../../dto/chargingstationGroup';
import { ChargingStationsService } from '../../../../services/entity/charging-stations.service';
import { FormService } from '../../../../services/form/form.service';

@Component({
  selector: 'app-edit-groups',
  templateUrl: './edit-groups.component.html',
  styleUrls: ['./edit-groups.component.scss']
})
export class EditGroupsComponent extends AbstractDialogContent implements OnInit {

  public className = 'EditGroupsComponent';

  @Input() public groupId: number
  @Input() public customerId: number;

  public group: ChargingstationGroupDto = new ChargingstationGroupDto();
  public chargingstations: ChargingStationDto[];
  public assignedChargingStations: ChargingStationDto[] = [];
  public users: UserDto[];
  public formCreated: boolean;
  public chargingstationsEdited: boolean = false;
  public usersEdited: boolean = false;

  constructor(public activeModal: NgbActiveModal, public formService: FormService, injector: Injector,
    private chargingStationsService: ChargingStationsService,
    private usersService: UsersService,
    private toastService: ToastService,
    private dialog: NgbModal
  ) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    this.loadGroup();
  }

  loadGroup() {
    this.chargingStationsService.getChargingstationGroup(this.groupId).subscribe(result => {
      this.group = plainToClass(ChargingstationGroupDto, result);
      this.loadChargingStations();
      this.loadUsers();
      this.createForm()
    }, error => {});
  }

  loadChargingStations() {
    if (this.customerId) {
      this.chargingStationsService.getChargingStationsOfCustomer(this.customerId).subscribe(result => {
        this.setupChargingStations(result);
      }, error => {});
    } else {
      this.chargingStationsService.getChargingStationsOfCurrentCustomer().subscribe(result => {
        this.setupChargingStations(result);
      }, error => {});
    }
  }

  loadUsers() {
    if (this.customerId) {
      this.usersService.getUsersOfCustomer(this.customerId).subscribe(result => {
        this.setupUsers(result);
      }, error => {});
    } else {
      this.usersService.getUsersOfCurrentCustomer().subscribe(result => {
        this.setupUsers(result);
      }, error => {});
    }
  }

  createForm() {
    this.formService.validators = {
      name: [Validators.required],
    }

    this.formService.form = new UntypedFormGroup({
      name: new UntypedFormControl(this.group.name, this.formService.validators['name']),
      description: new UntypedFormControl(this.group.description),
      selectedChargingstations: new UntypedFormControl(this.group.chargingStations.sort((a, b) => a.name?.localeCompare(b.name))),
      selectedUsers: new UntypedFormControl(this.group.users.sort((a, b) => a.fullName.localeCompare(b.fullName)))
    });

    this.formCreated = true;
  }


  onSubmit(formValue) {
    this.toastService.loading($localize`:@@SavingChangesToast:Änderungen werden gespeichert.`)
    var chargingStationGroupDto: ChargingstationGroupDto = {
      id: this.group.id,
      name: formValue.name,
      description: formValue.description,
      chargingStations: formValue.selectedChargingstations,
      users: formValue.selectedUsers,
      chargingstationsEdited: this.chargingstationsEdited,
      usersEdited: this.usersEdited
    };

    this.chargingStationsService.editChargingStationGroup(chargingStationGroupDto, this.group.id).subscribe(result => {
      this.toastService.success($localize`:@@SavingChangesSuccessToast:Änderungen gespeichert`, 0, true);
      this.activeModal.close();
    }, error => {
      this.toastService.error($localize`:@@SavingChangesErrorToast:Änderungen konnten nicht gespeichert werden`, 0, true);
    });
  }

  openDeleteDialog() {
    const dialogRef = this.dialog.open(DeleteGroupDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.groupId = this.groupId;

    dialogRef.result.then((result) => {
      if (result?.success) {
        this.activeModal.close();
      }
    }, (backdrop) => {});
  }


  setupChargingStations(chargingstations : ChargingStationDto[]) {
    this.chargingstations = chargingstations
    this.chargingstations = this.chargingstations
      .sort((a, b) => a.name.localeCompare(b.name))
  }

  setupUsers(users: UserDto[]) {
    this.users = users
    this.users = this.users
    .sort((a, b) => a.fullName.localeCompare(b.fullName))
  }

  chargingstationsChanged(){
    this.chargingstationsEdited = true;
  }

  usersChanged(){
    this.usersEdited = true;
  }
}
